import { OptionSubCategory, createLazyOption } from 'owa-options-core';
import { LazyModule } from 'owa-bundling';
let lazyFullModule = new LazyModule(() => import('./lazyFullOption'));
import { notificationSourcesTitle } from './ActivityFeedOption.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
export default {
    key: 'notificationSourcesCategory',
    titleStringKey: notificationSourcesTitle,
    options: [
        createLazyOption(
            {
                key: 'notificationSourcesOption_',
                titleStringKey: notificationSourcesTitle,
                hideTitleInFullOptions: true,
                searchTermsStringKey: notificationSourcesTitle,
                isHidden: () => {
                    return !isFeatureEnabled('auth-activityFeedOption');
                },
            },
            lazyFullModule,
            m => m.default
        ),
    ],
} as OptionSubCategory;
